var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',[(_vm.initOptions)?_c('v-chart',{attrs:{"init-options":_vm.initOptions,"options":_vm.spec.option,"autoresize":""}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }